import { useState } from 'react';
import { getRestaurantLinks, getBookingWindow } from '../restaurantLinks';

// Inline expander on every restaurant card surfacing all the booking
// options (OpenTable, Resy, TheFork, Google, Maps) + a booking-window
// hint so the user knows how far ahead to actually book this kind of
// place. PointsPilot doesn't book directly — we just put the user one
// click away from the right reservation site.
export default function RestaurantBookingPanel({ restaurant }) {
  const [open, setOpen] = useState(false);
  if (!restaurant) return null;
  const links = getRestaurantLinks(restaurant);
  const window = getBookingWindow(restaurant);

  return (
    <div className="mt-2 border border-brand-ink/10 rounded-lg overflow-hidden bg-brand-ink/[0.03]">
      <button
        onClick={(e) => { e.stopPropagation(); setOpen(o => !o); }}
        className="w-full px-3 py-2 flex items-center justify-between text-left hover:bg-brand-ink/[0.05] transition"
      >
        <div className="flex items-center gap-2 text-xs">
          <span className="text-gold font-bold">{open ? '▾' : '▸'}</span>
          <span className="font-bold text-brand-ink/85">How to book this reservation</span>
        </div>
        <span className={`text-[10px] font-medium px-2 py-0.5 rounded-full border ${
          window.urgent ? 'bg-rose-500/15 text-rose-300 border-rose-500/30' : 'bg-gold/15 text-gold border-gold/30'
        }`}>
          {window.urgent && '⚡ '}Book {window.window}
        </span>
      </button>

      {open && (
        <div
          className="px-3 pb-3 pt-1 space-y-2.5 text-xs"
          onClick={(e) => e.stopPropagation()}
        >
          <div className={`rounded-md p-2 border ${
            window.urgent ? 'bg-rose-500/8 border-rose-500/25' : 'bg-gold/8 border-gold/25'
          }`}>
            <div className="font-bold text-brand-ink/85 mb-0.5">When to book</div>
            <div className="text-brand-ink/75 leading-snug">{window.note}</div>
          </div>

          <div>
            <div className="font-bold text-brand-ink/85 mb-1.5">Try these (in order)</div>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-1.5">
              {links.map(l => (
                <a
                  key={l.label}
                  href={l.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`flex flex-col items-start gap-0.5 px-2 py-2 border rounded-md hover:opacity-90 transition ${l.color}`}
                  title={l.hint}
                >
                  <span className="font-bold flex items-center gap-1">
                    <span>{l.icon}</span>
                    <span>{l.label} ↗</span>
                  </span>
                  <span className="text-[10px] text-brand-ink/60 leading-tight">{l.hint}</span>
                </a>
              ))}
            </div>
          </div>

          <div className="text-[10px] text-brand-ink/55 italic">
            Tip: Open links in new tabs. If the restaurant isn't on any platform, search the restaurant name + "reservation" on Google — most have a direct booking widget on their own site.
          </div>
        </div>
      )}
    </div>
  );
}
